import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import MeetingOptions from "../MeetingOptions";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getAppScheduleMeetings, loadSheduleMeeting } from "../../app/store/candidate";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../../app/store/tools";

const SCHEDULE_MEETING_STYLES = {
  pageWrap: {
    padding: "12px 0 4px 0"
  },
  shell: {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "24px",
    boxShadow: "0 18px 38px rgba(15, 23, 42, 0.06)",
    overflow: "hidden"
  },
  hero: {
    padding: "24px 24px 18px 24px",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    flexWrap: "wrap"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "18px"
  },
  heroCopy: {
    flex: "1 1 360px",
    minWidth: "280px",
    display: "flex",
    alignItems: "flex-start",
    gap: "14px"
  },
  titleIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "24px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  titleCopy: {
    minWidth: 0
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "10px",
    color: "#4f46e5",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase"
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: 1.15
  },
  subtitle: {
    margin: "10px 0 0 0",
    color: "#475569",
    fontSize: "14px",
    lineHeight: 1.6,
  },
  heroActionRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 14px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    backgroundColor: "#ffffff",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 8px 22px rgba(37, 99, 235, 0.08)"
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    padding: "18px 22px 0 22px"
  },
  statCard: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    backgroundColor: "#ffffff",
    padding: "16px",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)"
  },
  statLabel: {
    margin: 0,
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: "10px 0 6px 0",
    color: "#0f172a",
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: 1
  },
  statMeta: {
    margin: 0,
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.5
  },
  tableWrap: {
    padding: "20px 24px 24px 24px"
  },
  sectionTitle: {
    margin: "0 0 6px 0",
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 700
  },
  sectionSubtitle: {
    margin: "0 0 18px 0",
    color: "#64748b",
    fontSize: "13px"
  },
  tableShell: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "20px",
    overflow: "auto",
    backgroundColor: "#ffffff"
  },
  tableHeader: {
    backgroundColor: "#f8fafc"
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  tableCell: {
    verticalAlign: "middle",
    padding: "16px"
  },
  serialBadge: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "13px",
    fontWeight: 800
  },
  datePrimary: {
    display: "block",
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 700
  },
  dateSecondary: {
    display: "block",
    color: "#64748b",
    fontSize: "13px"
  },
  optionList: {
    listStyle: "none",
    padding: 0,
    margin: 0
  },
  optionItem: {
    padding: "10px 12px",
    marginBottom: "8px",
    borderRadius: "12px",
    backgroundColor: "#f8fafc",
    border: "1px solid rgba(226, 232, 240, 1)",
    color: "#334155",
    fontSize: "13px",
    lineHeight: 1.5
  },
  acceptedItem: {
    padding: "10px 12px",
    borderRadius: "12px",
    backgroundColor: "#dcfce7",
    border: "1px solid rgba(134, 239, 172, 0.9)",
    color: "#166534",
    fontSize: "13px",
    fontWeight: 700,
    marginBottom: "10px"
  },
  infoText: {
    display: "block",
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.5
  },
  meetingLinksWrap: {
    display: "grid",
    gap: "8px"
  },
  meetingProviderPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "12px",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800,
    width: "fit-content"
  },
  meetingLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 12px",
    borderRadius: "12px",
    background: "rgba(37, 99, 235, 0.08)",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#2563eb",
    fontWeight: 700,
    textDecoration: "none",
    width: "fit-content"
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "36px",
    borderRadius: "999px",
    padding: "0 14px",
    fontWeight: 700,
    textDecoration: "none",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8"
  },
  acceptedBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "36px",
    padding: "0 14px",
    borderRadius: "999px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "12px",
    fontWeight: 800,
    border: "1px solid rgba(134, 239, 172, 0.9)"
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 700
  },
  emptyText: {
    margin: "10px auto 0 auto",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: 1.6
  }
};

export default function ScheduleMeeting() {

  const route = [{ name: "Task Management", url: "" }];
  const route1 = [{ name: "Contract Management", url: "" }];

  const usrType = localStorage.getItem("userType");

  const [scheduleMeetings, setScheduleMeetings] = useState([]);
  const [meetingShowHide, setMeetingShowHide] = useState(false);
  const [meetingObj, setMeetingObj] = useState(null);

  const meetingSelector = useSelector(getAppScheduleMeetings);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Schedule Appointments"));
    dispatch(setCurrentRoute(usrType === "candidate" ? route : route1))
  }, [])

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (meetingSelector.length === 0)
      dispatch(loadSheduleMeeting(usrId));
  }, []);

  useEffect(() => {
    if (meetingSelector.length > 0) {
      setScheduleMeetings(meetingSelector);
      let schItems = "";
      meetingSelector.map((x, key) => {
        if (key > 0) schItems += ",";
        schItems += x.id;
      })
      handleUpdateComponent(schItems, meetingSelector[0].ciid)
    } else {
      setScheduleMeetings([]);
    }
  }, [meetingSelector]);

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 11);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Schedule Appointment",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 11
    }
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }

  const handleMeetingModalShowHide = (meeting) => {
    setMeetingShowHide(!meetingShowHide);
    setMeetingObj(meeting)
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (meeting === "save") {
      dispatch(loadSheduleMeeting(usrId));
    }
  };

  const handleRefreshMeetings = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    dispatch(loadSheduleMeeting(usrId));
  };

  const getAcceptedMeetingDate = (meetingOptions) => {
    const meeting = (meetingOptions || []).filter((x) => x.status === true);
    if (meeting.length > 0) {
      return (
        <div style={SCHEDULE_MEETING_STYLES.acceptedItem}>
          <Moment format="MMM Do YYYY">{meeting[0].meetingDate}</Moment>
          &nbsp; {meeting[0].startTime} - {meeting[0].endTime}
        </div>
      );
    }

    return "";
  };

  const getMeetingProviderLabel = (provider) => {
    if (provider === "meet") return "Google Meet";
    if (provider === "team") return "Microsoft Team";
    if (provider === "zoom") return "Zoom";
    return provider;
  };

  const acceptedCount = scheduleMeetings.filter((item) => item.status).length;
  const pendingCount = scheduleMeetings.length - acceptedCount;
  const totalOptions = scheduleMeetings.reduce((sum, item) => sum + (item.options?.length || 0), 0);

  return (
    <React.Fragment>

      <div style={SCHEDULE_MEETING_STYLES.pageWrap}>
        <div style={SCHEDULE_MEETING_STYLES.shell}>
          <div style={SCHEDULE_MEETING_STYLES.hero}>
            <div style={SCHEDULE_MEETING_STYLES.heroRow}>
              <div style={SCHEDULE_MEETING_STYLES.heroCopy}>
                <div style={SCHEDULE_MEETING_STYLES.titleIcon}>
                  <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
                </div>
                <div style={SCHEDULE_MEETING_STYLES.titleCopy}>
                  <h2 style={SCHEDULE_MEETING_STYLES.title}>Schedule Meetings</h2>
                  <p style={SCHEDULE_MEETING_STYLES.subtitle}>
                    Meetings (In person, Video/Phone conference calls) as scheduled.
                  </p>
                </div>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.heroActionRow}>
                <button
                  type="button"
                  className="btn btn-sm"
                  style={SCHEDULE_MEETING_STYLES.refreshButton}
                  onClick={handleRefreshMeetings}
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                  Refresh
                </button>
                <span style={SCHEDULE_MEETING_STYLES.statusBadge}>
                  Pending Responses: {pendingCount}
                </span>
              </div>
            </div>
            <div style={SCHEDULE_MEETING_STYLES.statsRow}>
              <div style={SCHEDULE_MEETING_STYLES.statCard}>
                <p style={SCHEDULE_MEETING_STYLES.statLabel}>Total Meetings</p>
                <p style={SCHEDULE_MEETING_STYLES.statValue}>{scheduleMeetings.length}</p>
                <p style={SCHEDULE_MEETING_STYLES.statMeta}>Meeting requests currently available in your queue.</p>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statCard}>
                <p style={SCHEDULE_MEETING_STYLES.statLabel}>Accepted</p>
                <p style={SCHEDULE_MEETING_STYLES.statValue}>{acceptedCount}</p>
                <p style={SCHEDULE_MEETING_STYLES.statMeta}>Meetings with a confirmed date and time selection.</p>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statCard}>
                <p style={SCHEDULE_MEETING_STYLES.statLabel}>Awaiting Response</p>
                <p style={SCHEDULE_MEETING_STYLES.statValue}>{pendingCount}</p>
                <p style={SCHEDULE_MEETING_STYLES.statMeta}>Meeting requests that still need your response.</p>
              </div>
              <div style={SCHEDULE_MEETING_STYLES.statCard}>
                <p style={SCHEDULE_MEETING_STYLES.statLabel}>Time Options</p>
                <p style={SCHEDULE_MEETING_STYLES.statValue}>{totalOptions}</p>
                <p style={SCHEDULE_MEETING_STYLES.statMeta}>Available meeting slots proposed across all requests.</p>
              </div>
            </div>
          </div>

          <div style={SCHEDULE_MEETING_STYLES.tableWrap}>
            <div className="table-responsive" style={SCHEDULE_MEETING_STYLES.tableShell}>
              <table className="table align-items-center table-hover mb-0">
                <thead style={SCHEDULE_MEETING_STYLES.tableHeader}>
                  <tr>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}></th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Meeting Date & Time (Options)</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Meeting Date & Time (Accepted)</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Notes</th>
                    <th style={SCHEDULE_MEETING_STYLES.tableHeadCell}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {scheduleMeetings.length > 0 && scheduleMeetings.map((item, key) => (
                    <tr key={item.id || key}>
                      <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                        <span style={SCHEDULE_MEETING_STYLES.serialBadge}>{key + 1}</span>
                      </td>
                      <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                        <span style={SCHEDULE_MEETING_STYLES.datePrimary}>
                          <Moment format="MMM Do YYYY">
                            {item.createdDateTime}
                          </Moment>
                        </span>
                        <span style={SCHEDULE_MEETING_STYLES.dateSecondary}>
                          <Moment format="h:mm a">
                            {item.createdDateTime}
                          </Moment>
                        </span>
                      </td>
                      <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                        <ul style={SCHEDULE_MEETING_STYLES.optionList}>
                          {(item.options || []).map((o, optionIndex) => (
                            <li key={optionIndex} style={SCHEDULE_MEETING_STYLES.optionItem}>
                              <Moment format="MMM Do YYYY">
                                {o.meetingDate}
                              </Moment>{" "}
                              {o.startTime} - {o.endTime}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                        {getAcceptedMeetingDate(item.options)}
                        <div style={SCHEDULE_MEETING_STYLES.meetingLinksWrap}>
                          {item.meetingProvider?.split(",")
                            .map((m, key) => {
                              const providerLabel = getMeetingProviderLabel(m);
                              return (
                                <React.Fragment key={key}>
                                  {item.meetingLinks &&
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      style={SCHEDULE_MEETING_STYLES.meetingLink}
                                      href={
                                        item.meetingLinks.split(",")[key]
                                      }
                                    >
                                      <i className="fa fa-video-camera" aria-hidden="true"></i>
                                      Join {providerLabel}
                                    </a>}
                                  {!item.meetingLinks && (
                                    <span style={SCHEDULE_MEETING_STYLES.meetingProviderPill}>
                                      <i className="fa fa-video-camera" aria-hidden="true"></i>
                                      {providerLabel}
                                    </span>
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </td>
                      <td style={{ ...SCHEDULE_MEETING_STYLES.tableCell, whiteSpace: "pre-wrap" }}>
                        <span style={SCHEDULE_MEETING_STYLES.infoText}>{item.remarks || "No notes available"}</span>
                      </td>
                      <td style={SCHEDULE_MEETING_STYLES.tableCell}>
                        {item.status ? (
                          <span style={SCHEDULE_MEETING_STYLES.acceptedBadge}>Accepted</span>
                        ) : (
                          <button
                            style={SCHEDULE_MEETING_STYLES.actionButton}
                            onClick={() => handleMeetingModalShowHide(item)}
                          >
                            Accept
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                  {scheduleMeetings.length === 0 && (
                    <tr>
                      <td colSpan={6} className="p-0">
                        <div style={SCHEDULE_MEETING_STYLES.emptyState}>
                          <div style={SCHEDULE_MEETING_STYLES.emptyIcon}>
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                          </div>
                          <h4 style={SCHEDULE_MEETING_STYLES.emptyTitle}>No appointments scheduled yet</h4>
                          <p style={SCHEDULE_MEETING_STYLES.emptyText}>
                            Meeting requests and accepted appointment slots will appear here once they are created for your account.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
      <MeetingOptions
        meetingShowHide={meetingShowHide}
        handleMeetingModalShowHide={handleMeetingModalShowHide}
        meeting={meetingObj}
      ></MeetingOptions>
    </React.Fragment>
  );
}
